import { render, staticRenderFns } from "./ast.vue?vue&type=template&id=59db8be8&scoped=true&"
import script from "./ast.vue?vue&type=script&lang=js&"
export * from "./ast.vue?vue&type=script&lang=js&"
import style0 from "./ast.vue?vue&type=style&index=0&id=59db8be8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59db8be8",
  null
  
)

export default component.exports